import Vue from 'vue';
import {useLoginStore} from '@/store/pinia/login.store';

export const setupLoginSection = () => {
  const loginStore = useLoginStore();

  Vue.component('LoginSection', () => import('./components/LoginSection.vue'));
  loginStore.addLoginComponent({
    name:'login-section',
  });
};
